"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RECORD_ID_FIELD_SUFFIX_MAX_LENGTH = exports.RECORD_ID_FIELD_PREFIX_MAX_LENGTH = void 0;
exports.RECORD_ID_FIELD_PREFIX_MAX_LENGTH = 20;
exports.RECORD_ID_FIELD_SUFFIX_MAX_LENGTH = 20;
